import { flattenValues } from '../../../../../../../common/AllKnownDetails/utils/allKnownDetailsUtils';
import SourceGroupEntries from '../../../../../../../common/AllKnownDetails/components/SourceGroupEntries/SourceGroupEntries';
import {
    DIRECTOR_KNOWN_VALUES_KEY,
    EMPTY_VALUE_PLACEHOLDER,
    KNOWN_DETAIL_CARD_ORDER,
    KNOWN_DETAIL_TAB_LABEL,
} from '../../../../../../../common/AllKnownDetails/constants';
import type { KnownDetailType } from '../../../../../../../common/AllKnownDetails/types';
import type { KnownDetailsCardKey, KnownDetailsCardsProps } from './ManagementUserProfile.types';
import CollapsibleCard from './CollapsibleCard';
import styles from './KnownDetailsCards.module.scss';

const CARD_KEY: Record<KnownDetailType, KnownDetailsCardKey> = {
    NAME: 'knownNames',
    ADDRESS: 'knownAddresses',
    PHONE: 'knownContacts',
    EMAIL: 'knownEmails',
};

const KnownDetailsCards = ({ knownValues, expanded, onToggle }: KnownDetailsCardsProps) => {
    const cards = KNOWN_DETAIL_CARD_ORDER.map((type) => {
        const field = DIRECTOR_KNOWN_VALUES_KEY[type];
        const groups = knownValues?.[field] ?? [];
        return { type, field, groups, hasValues: flattenValues(groups).length > 0 };
    });
    // Nothing known anywhere hides the whole set, as the All Known Details card does; a single empty type keeps its card.
    if (!cards.some((card) => card.hasValues)) return null;

    return (
        <>
            {cards.map(({ type, field, groups, hasValues }) => {
                const key = CARD_KEY[type];
                return (
                    <CollapsibleCard
                        key={key}
                        id={`known-${field}-panel`}
                        title={`Known ${KNOWN_DETAIL_TAB_LABEL[type]}`}
                        expanded={expanded[key]}
                        onToggle={() => onToggle(key)}
                        variant="known"
                    >
                        <div className={styles.KnownDetailsBody}>
                            {hasValues ? (
                                <SourceGroupEntries groups={groups} type={type} entityType="MANAGEMENT_PROFILE" />
                            ) : (
                                EMPTY_VALUE_PLACEHOLDER
                            )}
                        </div>
                    </CollapsibleCard>
                );
            })}
        </>
    );
};

export default KnownDetailsCards;
